import { SxProps, Theme } from '@mui/material';
import { DESKTOP_MIN_WIDTH } from '../constants';

type stylesType = SxProps<Theme>;

export const rootSx: stylesType = (theme) => ({
	display: 'flex',
	flexDirection: 'column',
	gap: '10px',
	borderRadius: 0,
	width: '100%',
	minHeight: '352px',

	[theme.breakpoints.up(DESKTOP_MIN_WIDTH - 1)]: {
		paddingTop: 0,
		minHeight: '679px',
	},

	'&:hover': {
		boxShadow: 3,
	},
	'&:focus-visible': {
		outline: 0,
	},
});

export const topContentSx: stylesType = (theme) => ({
	display: 'flex',
	gap: '10px',
	padding: '10px',
	paddingBottom: 0,

	[theme.breakpoints.up(DESKTOP_MIN_WIDTH - 1)]: {
		flexDirection: 'column',
		padding: 0,
	},
});

export const topInnerContentSx = (theme: Theme, isBundle: boolean): stylesType => ({
	display: 'flex',
	flexDirection: 'column',
	gap: '10px',

	[theme.breakpoints.up(DESKTOP_MIN_WIDTH - 1)]: {
		flexDirection: 'column',
		padding: '10px',
		paddingTop: 0,
		paddingBottom: 0,
		...(!isBundle && { height: '108px' }),
	},
});

export const middleContentSx: SxProps<Theme> = {
	display: 'flex',
	flexDirection: 'column',
	gap: '10px',
	padding: '10px',
	paddingTop: 0,
	paddingBottom: 0,
};

export const bottomContentSx: SxProps<Theme> = {
	display: 'flex',
	flexDirection: 'column',
	flexGrow: 1,
	gap: '10px',
	padding: '10px',
	paddingTop: 0,
};

export const spacerSx: SxProps<Theme> = {
	flexGrow: 1,
};

export const reservedSlotSx = (
	mobileHeight: number,
	desktopHeight = mobileHeight
): SxProps<Theme> => ({
	display: mobileHeight === 0 ? 'none' : 'block',
	height: `${mobileHeight}px`,
	flexShrink: 0,

	[`@media (min-width: ${DESKTOP_MIN_WIDTH}px)`]: {
		display: desktopHeight === 0 ? 'none' : 'block',
		height: `${desktopHeight}px`,
	},
});
